module.exports = fox._r("fonts/museosanscyrl-webfont.ttf", __webpack_public_path__ + "fonts/2qJvVG5.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/museosanscyrl-webfont.ttf
// module id = 576
// module chunks = 2